var map = {
	"./agro.svg": "6bf3",
	"./apertura.svg": "bc63",
	"./contenedor.svg": "bb89",
	"./energy.svg": "04da",
	"./etiquetas.svg": "fbaf",
	"./gas.svg": "56cf",
	"./gateways_admin.svg": "5391",
	"./mascotas.svg": "2ace",
	"./moobel.svg": "cfe9",
	"./panicbutton.svg": "f8bb",
	"./pointtracker.svg": "c349",
	"./polucion.svg": "b6e6",
	"./smart_agro.svg": "17c29",
	"./smarthue.svg": "2c00",
	"./sonido.svg": "cd7e",
	"./ssmartlocator.svg": "5d9e",
	"./temperature.svg": "e077",
	"./water.svg": "3206"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4827";